// Available Tenant level Licenses
export enum TENANT_LICENSES {
  PERSONALISED_NOTIFICATIONS = 'PERSONALISED_NOTIFICATIONS',
  POLLING_NOTIFICATIONS = 'POLLING_NOTIFICATIONS',
  PLATFORM_CONTENT_HOSTING = 'PLATFORM_CONTENT_HOSTING'
}
